import { render, staticRenderFns } from "./ReviewViewPage.vue?vue&type=template&id=0cbad542&scoped=true"
import script from "./ReviewViewPage.vue?vue&type=script&lang=js"
export * from "./ReviewViewPage.vue?vue&type=script&lang=js"
import style0 from "./ReviewViewPage.vue?vue&type=style&index=0&id=0cbad542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbad542",
  null
  
)

export default component.exports